var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "handle-wrap" }, [
    _c(
      "p",
      {
        class: _vm.permsBool ? "color-success" : "color-dis",
        on: { click: _vm.toEdit }
      },
      [_vm._v("\n    编辑\n  ")]
    ),
    _c(
      "p",
      {
        class: _vm.permsBool ? "color-success" : "color-dis",
        on: { click: _vm.switchStatus }
      },
      [_vm._v("\n    " + _vm._s(_vm.statuText) + "\n  ")]
    ),
    _vm.data.status !== 2
      ? _c(
          "p",
          {
            class:
              _vm.permsBool && _vm.data.status === 1
                ? "color-success"
                : "color-dis",
            on: { click: _vm.del }
          },
          [_vm._v("\n    删除\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74776433", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74776433","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/dingComponents/FlowHandles.vue
// module id = /9pw
// module chunks = 7 55 92 205